// Cross-subdomain cookie helpers (domain=.lookoptic.com), defined once and
// shared across the LOOK OPTIC theme scripts so state written on
// www.lookoptic.com is visible on try.lookoptic.com and vice-versa.
(function () {
    if (window.__sharedCookieHelpersInstalled) return;
    window.__sharedCookieHelpersInstalled = true;

    window.setSharedCookie = function (name, value, days) {
        document.cookie =
            name + "=" + encodeURIComponent(value) +
            "; domain=.lookoptic.com; path=/; SameSite=Lax; Secure" +
            "; max-age=" + (days * 86400);
    };

    window.getSharedCookie = function (name) {
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        for (var i = 0; i < cookies.length; i++) {
            var idx = cookies[i].indexOf("=");
            var key = idx > -1 ? cookies[i].slice(0, idx) : cookies[i];
            if (key === name) {
                return decodeURIComponent(idx > -1 ? cookies[i].slice(idx + 1) : "");
            }
        }
        return null;
    };

    window.removeSharedCookie = function (name) {
        document.cookie = name + "=; domain=.lookoptic.com; path=/; max-age=0";
    };
})();

// Older key generations hold offers from earlier campaigns (Labor Day in the
// un-versioned keys, pre-October 2026 welcome offers in _v2, pre-Halloween 2026
// offers in _v3). All readers and writers use the _v4 keys, so purge the old
// ones rather than migrate them.
// Kept outside the helper block above: shipping-threshold-handler.js loads first
// and installs the helpers, so that block returns early.
["welcome_offer", "welcome_offer_v2", "welcome_offer_v3"].forEach((name) => {
    removeSharedCookie(name);
    window.localStorage.removeItem(name);
});
window.localStorage.removeItem("ExclusiveOffer");
window.localStorage.removeItem("ExclusiveOffer_v2");
window.localStorage.removeItem("ExclusiveOffer_v3");

// Sitewide sale code, or null when no sale is running. While set, the sale owns
// the discount and never reads or writes the welcome_offer_v4 /
// ExclusiveOffer_v4 keys, so visitors' real welcome offers survive it.
window.SITEWIDE_SALE_CODE = "BF26";
// The sale also runs as a super-app automatic discount, so its code is never pushed
// into carts (a code alongside the automatic one can't combine). Clear for a code-only sale.
window.SITEWIDE_SALE_AUTOMATIC = true;
const isAutomaticSaleCode = (code) => window.SITEWIDE_SALE_AUTOMATIC && code === window.SITEWIDE_SALE_CODE;

window.utilWelcomeOffer = function(
    offerBody,
    offerAmount,
    offerCode,
    override = false
) {
    const offerDetails = {
        body: offerBody,
        code: offerCode,
        amount: offerAmount,
    };
    window.offerDetails = {
        discountCode: offerCode,
        discountAmount: offerAmount
    };
    // The /discount fetch only works same-origin; other subdomains (try.) hand
    // the code over via the shared cookie and applySharedWelcomeOfferOnWww below.
    if (window.location.hostname === "www.lookoptic.com" && !isAutomaticSaleCode(offerCode) && (!document.cookie.includes(`discount_code=${window.offerDetails.discountCodeOverride ? window.offerDetails.discountCodeOverride : window.offerDetails.discountCode}`)) && window.welcomeOfferActive === true) {
      document.cookie = "discount_code=remove; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.lookoptic.com; path=/;";

      fetch(
        `https://www.lookoptic.com/discount/${window.offerDetails.discountCodeOverride ? window.offerDetails.discountCodeOverride : window.offerDetails.discountCode}`
      );
    }
    // Prefer the shared cookie, fall back to localStorage during rollout.
    const existingWelcomeOffer =
        getSharedCookie("welcome_offer_v4") || window.localStorage.getItem("welcome_offer_v4");
    if (offerCode !== window.SITEWIDE_SALE_CODE && (!existingWelcomeOffer || override)) {
        // JSON is stringified BEFORE encoding (setSharedCookie encodes) and
        // parsed AFTER decoding by any reader.
        const welcomeOfferValue = JSON.stringify(offerDetails);
        // Dual-write: shared cookie (cross-subdomain) + localStorage (legacy readers).
        setSharedCookie("welcome_offer_v4", welcomeOfferValue, 7);
        window.localStorage.setItem("welcome_offer_v4", welcomeOfferValue);
    }
    if (window._welcomeOfferObserver) {
        window._welcomeOfferObserver.disconnect();
        window._welcomeOfferObserver = null;
    }
    if (window._welcomeOfferDebounceTimer) {
        clearTimeout(window._welcomeOfferDebounceTimer);
        window._welcomeOfferDebounceTimer = null;
    }

    const BODY_SELECTOR = "span[data-welcome-offer-body]";
    const CODE_SELECTOR = "span[data-welcome-offer-code]";
    const AMOUNT_SELECTOR = "span[data-welcome-offer-amount]";

    function replaceOfferBody(el) {
        if (el.dataset.offerBodyReplaced && !override) return;
        el.innerHTML = offerDetails.body;
        el.dataset.offerBodyReplaced = "true";
    }

    function replaceOfferCode(el) {
        if (el.dataset.offerCodeReplaced && !override) return;
        el.innerHTML = offerDetails.code;
        el.dataset.offerCodeReplaced = "true";
    }

    function replaceOfferAmount(el) {
        if (el.dataset.offerAmountReplaced && !override) return;
        el.innerHTML = offerDetails.amount;
        el.dataset.offerAmountReplaced = "true";
    }

    function handleInitialElements() {
        document
            .querySelectorAll(BODY_SELECTOR)
            .forEach((el) => replaceOfferBody(el));
        document
            .querySelectorAll(CODE_SELECTOR)
            .forEach((el) => replaceOfferCode(el));
        document
            .querySelectorAll(AMOUNT_SELECTOR)
            .forEach((el) => replaceOfferAmount(el));

        document.documentElement.classList.add('welcome-offer-active');
    }

    function processQueuedNodes() {
        if (
            window._welcomeOfferNodeQueue &&
            window._welcomeOfferNodeQueue.length > 0
        ) {
            const nodes = [...window._welcomeOfferNodeQueue];
            window._welcomeOfferNodeQueue = [];

            nodes.forEach((node) => {
                try {
                    if (node.nodeType !== 1) return;
                    if (node.matches?.(BODY_SELECTOR)) {
                        replaceOfferBody(node);
                    } else if (node.matches?.(CODE_SELECTOR)) {
                        replaceOfferCode(node);
                    } else if (node.matches?.(AMOUNT_SELECTOR)) {
                        replaceOfferAmount(node);
                    }
                    node
                        .querySelectorAll?.(BODY_SELECTOR)
                        .forEach((child) => replaceOfferBody(child));
                    node
                        .querySelectorAll?.(CODE_SELECTOR)
                        .forEach((child) => replaceOfferCode(child));
                    node
                        .querySelectorAll?.(AMOUNT_SELECTOR)
                        .forEach((child) => replaceOfferAmount(child));
                } catch (e) {
                    console.warn("Welcome offer replacement error:", e);
                }
            });
        }
    }

    function observeNewElements() {
        window._welcomeOfferNodeQueue = [];

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    window._welcomeOfferNodeQueue.push(node);
                });
            });

            if (window._welcomeOfferDebounceTimer) {
                clearTimeout(window._welcomeOfferDebounceTimer);
            }

            window._welcomeOfferDebounceTimer = setTimeout(() => {
                processQueuedNodes();
                window._welcomeOfferDebounceTimer = null;
            }, 50);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        window._welcomeOfferObserver = observer;
    }

    function waitForElementToDisplay(
        selector,
        callback,
        interval = 100,
        timeout = 10000
    ) {
        const start = Date.now();
        const timer = setInterval(() => {
            if (document.querySelector(selector)) {
                clearInterval(timer);
                callback();
            } else if (Date.now() - start > timeout) {
                clearInterval(timer);
                console.warn(
                    `waitForElementToDisplay: Timed out waiting for ${selector}`
                );
            }
        }, interval);
    }
    // Landing pages on try.lookoptic.com only carry amount spans, so waiting on
    // the body span alone would time out there and never replace anything.
    waitForElementToDisplay(
        `${BODY_SELECTOR}, ${CODE_SELECTOR}, ${AMOUNT_SELECTOR}`,
        () => {
            handleInitialElements();
            observeNewElements();
        },
        100,
        10000
    );
};

// On www.lookoptic.com, apply a discount that was captured on another subdomain
// (e.g. try.lookoptic.com) and handed over via the shared welcome_offer_v4 cookie.
// The /discount fetch from the landing pages is a cross-origin no-op, so the main
// site establishes the discount itself (same-origin fetch) when it finds the cookie.
(function applySharedWelcomeOfferOnWww() {
    if (window.location.hostname !== "www.lookoptic.com" || window.SITEWIDE_SALE_CODE) return;
    var stored = getSharedCookie("welcome_offer_v4");
    if (!stored) return;
    var code;
    try {
        code = JSON.parse(stored).code;
    } catch (e) {
        return;
    }
    // Nothing to apply, or this code is already the active discount.
    if (!code || document.cookie.includes("discount_code=" + code)) return;
    document.cookie = "discount_code=remove; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.lookoptic.com; path=/;";
    fetch("https://www.lookoptic.com/discount/" + code);
})();

// The offer's /discount request can land on a cart the browser then discards: on a
// visitor's first www page it races prime-cart.liquid's cart write, so the
// discount_code cookie stays set while the cart holding the items carries no code.
// The cookie is not proof, so once the cart has items check its own discounts and
// re-apply once per cart; the checkout applies the code regardless. Third-party
// cart writes (Intelligems, Elevar) land in the same first seconds and can
// overwrite a code that was just attached, so the cart is read back and the
// request repeated once more when it still lacks the code.
window.addEventListener("cart:update", (event) => {
    const cart = event.detail && event.detail.cart;
    const code = window.offerDetails && window.offerDetails.discountCode;
    if (window.location.hostname !== "www.lookoptic.com" || !window.welcomeOfferActive || !code || isAutomaticSaleCode(code) || !cart || !cart.items.length) return;
    // No cookie yet: the offer's own request applies it.
    if ((getSharedCookie("discount_code") || "").toLowerCase() !== code.toLowerCase()) return;
    const carriesCode = (current) => current.cart_level_discount_applications.concat(...current.items.map((item) => item.discounts)).some((discount) => discount.title.toLowerCase() === code.toLowerCase());
    if (carriesCode(cart)) return;
    if (window.sessionStorage.getItem("lo_discount_retry") === cart.token) return;
    window.sessionStorage.setItem("lo_discount_retry", cart.token);
    const apply = (attempt) => fetch(`https://www.lookoptic.com/discount/${code}`)
        .then(() => fetch("/cart.js"))
        .then((response) => response.json())
        .then((fresh) => (attempt < 2 && !carriesCode(fresh) ? apply(attempt + 1) : fresh));
    apply(1)
        .then(() => {
            const drawer = document.querySelector("cart-notification");
            const ids = drawer.getSectionsToRender().map((section) => section.id);
            return fetch(`${window.location.pathname}?sections=${ids.join(",")}`)
                .then((response) => response.json())
                .then((sections) => drawer.renderContentsPassively({ sections }));
        })
        .catch(() => {});
});

// Off-www (try.lookoptic.com landing pages, review apps): replay a previously
// captured offer on later page views. The popup only fires once, and the
// Intelligems variation JS is a one-shot querySelectorAll that misses spans
// rendered after it runs; replaying through utilWelcomeOffer drives the
// observer-based replacement instead. On www this stays off — www has its own
// offer pipeline. During a sitewide sale it stays off too: the sale owns the
// amount, so a stored welcome offer must not swap the landing pages' spans.
(function replayWelcomeOfferOffWww() {
    if (window.location.hostname === "www.lookoptic.com" || window.SITEWIDE_SALE_CODE) return;
    var stored = getSharedCookie("welcome_offer_v4") || window.localStorage.getItem("welcome_offer_v4");
    if (!stored) return;
    try {
        var offer = JSON.parse(stored);
        if (offer && offer.amount) {
            window.utilWelcomeOffer(offer.body, offer.amount, offer.code);
        }
    } catch (e) {
        // Malformed cookie — leave the page's default offer copy alone.
    }
})();
